import Script from 'react-load-script';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

@inject('flexFrameStore')
@observer
export default class FlexFrame extends Component {
    state = {
        scriptDetails: null
    }

    constructor(props) {
        super(props);
        this.setScriptDetails = this.setScriptDetails.bind(this);
    }

    componentDidMount() {
        const { flexFrameStore } = this.props;
        flexFrameStore.getFlexKey(this.setScriptDetails);
    }

    setScriptDetails(scriptDetails) {
        this.setState({ scriptDetails });
    }

    render() {
        const { scriptDetails } = this.state;
        const { flexFrameStore } = this.props;

        return (
            // eslint-disable-next-line quotes
            <>
                {scriptDetails &&
                    <Script
                        async
                        attributes={{ crossOrigin: 'anonymous', integrity: scriptDetails?.ctx[0]?.data?.clientLibraryIntegrity }}
                        onLoad={() => {
                            flexFrameStore.setKey(scriptDetails?.RawJwt);
                        }}
                        url={scriptDetails?.ctx[0]?.data?.clientLibrary}
                    />
                // eslint-disable-next-line quotes
                }
            </>
        );
    }
}
